export default {
  pages: {
    createApplicationPage: {
      secondaryTitle: 'Mijoz',
    },
  },
};
